import { templateBarbearia } from "./Barbearia";
import { templatePizzaria } from "./Pizzaria";
import { templateHamburgueria } from "./Hamburgueria";
import { templateDrinksBar } from "./DrinksBar";
import { templateCafe } from "./Cafe";
import { templateAcai } from "./Acai";
import { templateSushi } from "./Sushi";
import { templatePadaria } from "./Padaria";
import { templateSorveteria } from "./Sorveteria";
import { templateRestaurante } from "./Restaurante";

export const templatesCardapio = {
  barbearia: templateBarbearia,
  pizzaria: templatePizzaria,
  hamburgueria: templateHamburgueria,
  bar: templateDrinksBar,
  cafe: templateCafe,
  acai: templateAcai,
  sushi: templateSushi,
  padaria: templatePadaria,
  sorveteria: templateSorveteria,
  restaurante: templateRestaurante
};